import { render, staticRenderFns } from "./App.vue?vue&type=template&id=48bc452c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=48bc452c&prod&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=48bc452c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bc452c",
  null
  
)

export default component.exports